import React from 'react'
import { Box, Button, Card, CardContent, CardHeader, Divider, Toolbar } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import Filter from '../component/filter'
import { useExport } from '../hooks/useExport'
import { useSelector } from 'react-redux'
import { getExportConfig } from '../component/config/exportConfig'
import ChatWidget from '../dashboard/chat/ChatWidget'
import { ifAnyGranted } from '../auth'

function getTitle(pathname) {
    switch (pathname) {
        case '/':
            return 'Dashboard'
        case '/sales':
            return 'Vendas'
        case '/financial':
            return 'Financeiro'
        case '/product':
            return 'Produto'
        case '/customer':
            return 'Clientes'
        case '/checking':
            return 'Auditoria: Itens cancelados'
        case '/orderIntegration':
            return 'Auditoria: Pedidos não importados'
        case '/paymentExclusion':
            return 'Auditoria: Exclusões de pagamentos'
        case '/unauthorized':
            return 'Acesso negado'
        case '/franchise':
            return 'Performance das unidades'
        case '/performanceOperation':
            return 'Performance da operação: Tempo por status dos pedidos'
        default:
            return 'Dashboard'
    }
}

function LayoutActions({ pathname, disabled, onClick }) {

    switch (pathname) {
        default:
            return (
                <Button
                    variant="text"
                    disabled={disabled}
                    onClick={onClick}>
                    Exportar dados
                </Button>
            )
    }
}

export function AuthorizedDefaultLayout() {
    const location = useLocation()
    const kpiRealTime = useSelector((state) => state.kpiRealTime)
    const kpiSales = useSelector((state) => state.kpiSales)
    const kpiProduct = useSelector((state) => state.kpiProduct)
    const kpiCustomer = useSelector((state) => state.kpiCustomer)
    const kpiChecking = useSelector((state) => state.kpiChecking)
    const kpiOrderIntegration = useSelector((state) => state.kpiOrderIntegration)
    const kpiPaymentExclusion = useSelector((state) => state.kpiPaymentExclusion)
    const searched = useSelector((state) => state.progress.searched)
    const { handleExport } = useExport()
    const haDataToExport = !hasData(location.pathname)

    function getData(pathname) {
        switch (pathname) {
            case '/':
                return kpiRealTime?.listAllSalesToday || [];
            case '/sales':
                return kpiSales?.listAllSales || [];
            case '/product':
                return kpiProduct?.currentMonthSalesProduct || [];
            case '/customer':
                return kpiCustomer?.listAllSalesCustomer || []
            case '/checking':
                return kpiChecking?.listAllChecking || [];
            case '/orderIntegration':
                return kpiOrderIntegration?.listAllOrderIntegration || [];
            case '/paymentExclusion':
                return kpiPaymentExclusion?.listAllPaymentExclusion || [];
            default:
                return [];
        }
    }

    function hasData(pathname) {
        switch (pathname) {
            case '/':
                return kpiRealTime?.listAllSalesToday?.length > 0
            case '/sales':
                return kpiSales?.listAllSales?.length > 0
            case '/product':
                return kpiProduct?.currentMonthSalesProduct?.length > 0
            case '/customer':
                return kpiCustomer?.listAllSalesCustomer?.length > 0
            case '/checking':
                return kpiChecking?.listAllChecking?.length > 0
            case '/orderIntegration':
                return kpiOrderIntegration?.listAllOrderIntegration?.length > 0
            case '/paymentExclusion':
                return kpiPaymentExclusion?.listAllPaymentExclusion?.length > 0
        }
    }

    const handleExportClick = () => {
        const data = getData(location.pathname);

        const options = getExportConfig(location.pathname);

        const filename = getTitle(location.pathname);

        handleExport(data, options, filename);
    };


    return (
        <>
            <Toolbar />

            <Box pb={2}>
                <Filter />
            </Box>

            <Card
                sx={{
                    transition: 'opacity 0.3s ease, filter 0.3s ease',
                    // Enquanto nenhuma busca foi feita, o conteúdo fica esmaecido
                    // e sem interação, mantendo o foco no filtro / botão Buscar.
                    ...(!searched && {
                        opacity: 0.4,
                        filter: 'grayscale(0.5)',
                        pointerEvents: 'none',
                        userSelect: 'none',
                    }),
                }}
            >
                <CardHeader
                    title={getTitle(location.pathname)}
                    titleTypographyProps={{
                        variant: "h4",
                        component: "h2",
                        style: { textAlign: "left" }
                    }}
                    action={
                        <LayoutActions
                            disabled={haDataToExport}
                            pathname={location.pathname}
                            onClick={handleExportClick}>
                            Exportar dados
                        </LayoutActions>
                    }
                />

                <Divider />

                <CardContent>
                    <Outlet />
                </CardContent>
            </Card>

            {/* Consultor de IA só aparece pra quem tem a permissão liberada */}
            {ifAnyGranted('PERMITE_ACESSAR_CHAT_IA') && <ChatWidget />}
        </>
    )
}